import * as React from "react";
import { forwardRef } from "react";
const SvgTracked = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g fill="none" fillRule="evenodd"><circle cx={8} cy={8} r={8} fill="currentColor" /><path stroke="#000" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.556 5.333L7.824 11.11c-.168.259-.424.42-.703.444-.278.023-.552-.095-.75-.324L4.444 8.993" /></g></svg>;
const ForwardRef = forwardRef(SvgTracked);
export { ForwardRef as ReactComponent };